import React, { useContext, useEffect } from 'react';
import { AppSettings } from '../../config/app-settings.js';

const CenterPhilMontessori = () => {
    const context = useContext(AppSettings);
    
    useEffect(() => {
        // Set sidebar as collapsed when component mounts
        context.setAppSidebarCollapsed(true);
        
        // Cleanup: restore sidebar to expanded when component unmounts
        return function cleanUp() {
            context.setAppSidebarCollapsed(false);
        };
    }, []);

    return (
        <div>
            {/* Hero Section */}
            <div className="container-fluid" style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '60px 0',
                marginBottom: '40px',
                color: 'white'
            }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-8 col-md-7">
                            <h2 className="fw-bold mb-3" style={{
                                fontSize: 'clamp(2rem, 5vw, 3.5rem)',
                                lineHeight: '1.2',
                                whiteSpace: 'nowrap'
                            }}>
                                Welcome to<br />
                                <span style={{color: '#ffd700'}}>CenterPhil Montessori</span>
                            </h2>
                            <p className="lead mb-4" style={{fontSize: '1.1rem', lineHeight: '1.6'}}>
                                Nurturing young minds through the Montessori philosophy of education. 
                                Our school provides a prepared environment where children can explore, 
                                discover, and grow at their own pace.
                            </p>
                            <div className="d-flex flex-wrap gap-3">
                                <div className="d-flex align-items-center">
                                    <div className="me-2">
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                        </svg>
                                    </div>
                                    <span>Excellence in Education</span>
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="me-2">
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A2.01 2.01 0 0 0 18 7c-.71 0-1.35.38-1.69.94L12 17.5l-4.31-9.56A2.01 2.01 0 0 0 6 7c-.71 0-1.35.38-1.69.94L1.77 16H4.5v6h15.5z"/>
                                        </svg>
                                    </div>
                                    <span>Child-Centered Learning</span>
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="me-2">
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                                        </svg>
                                    </div>
                                    <span>Proven Results</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-5 text-center">
                            <div style={{
                                background: 'rgba(255,255,255,0.1)',
                                backdropFilter: 'blur(10px)',
                                borderRadius: '20px',
                                padding: '30px',
                                border: '1px solid rgba(255,255,255,0.2)'
                            }}>
                                <svg width="80" height="80" fill="currentColor" viewBox="0 0 24 24" className="mb-3">
                                    <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
                                </svg>
                                <h4>Education Hub</h4>
                                <p className="mb-0">Your gateway to educational resources and information</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                {/* Quick Stats */}
                <div className="row mb-5">
                    <div className="col-md-3 col-6 mb-3">
                        <div className="text-center p-4" style={{
                            background: 'linear-gradient(45deg, #ff9a9e 0%, #fecfef 100%)',
                            borderRadius: '15px',
                            color: 'white'
                        }}>
                            <h3 className="fw-bold mb-2">200+</h3>
                            <p className="mb-0">Happy Students</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                        <div className="text-center p-4" style={{
                            background: 'linear-gradient(45deg, #a8edea 0%, #fed6e3 100%)',
                            borderRadius: '15px',
                            color: '#333'
                        }}>
                            <h3 className="fw-bold mb-2">20+</h3>
                            <p className="mb-0">Expert Teachers</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                        <div className="text-center p-4" style={{
                            background: 'linear-gradient(45deg, #ffecd2 0%, #fcb69f 100%)',
                            borderRadius: '15px',
                            color: '#333'
                        }}>
                            <h3 className="fw-bold mb-2">25+</h3>
                            <p className="mb-0">Years Experience</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                        <div className="text-center p-4" style={{
                            background: 'linear-gradient(45deg, #a8caba 0%, #5d4e75 100%)',
                            borderRadius: '15px',
                            color: 'white'
                        }}>
                            <h3 className="fw-bold mb-2">100%</h3>
                            <p className="mb-0">Parent Satisfaction</p>
                        </div>
                    </div>
                </div>

                {/* Documents Section */}
                <div className="row">
                    <div className="col-12">
                        <h2 className="mb-4 text-center">
                            <svg width="32" height="32" fill="currentColor" viewBox="0 0 24 24" className="me-2">
                                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                            </svg>
                            Important Documents
                        </h2>
                        
                        <div className="row justify-content-center">
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="card h-100 shadow-sm" style={{
                                    borderRadius: '15px',
                                    border: 'none',
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white'
                                }}>
                                    <div className="card-body text-center p-4">
                                        <div className="mb-3">
                                            <svg width="64" height="64" fill="currentColor" viewBox="0 0 24 24">
                                                <path d="M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M19,19H5V5H19V19M17,12H7V10H17V12M15,16H7V14H15V16M17,8H7V6H17V8Z"/>
                                            </svg>
                                        </div>
                                        <h5 className="card-title fw-bold">PFA Bylaws</h5>
                                        <p className="card-text mb-4">
                                            Official Parent Faculty Association bylaws and governance documents
                                        </p>
                                        <a 
                                            href="https://galeforceai-public.s3.us-east-2.amazonaws.com/centerphilmontessori/CenterPhil_Montessori_PFA_Bylaws.pdf" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="btn btn-light btn-lg"
                                            style={{borderRadius: '25px'}}
                                        >
                                            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24" className="me-2">
                                                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                                            </svg>
                                            View PDF
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Additional Info Section */}
                <div className="row mt-5 mb-5">
                    <div className="col-12">
                        <div className="text-center p-5" style={{
                            background: 'linear-gradient(45deg, #f093fb 0%, #f5576c 100%)',
                            borderRadius: '20px',
                            color: 'white'
                        }}>
                            <h3 className="fw-bold mb-3">More Resources Coming Soon</h3>
                            <p className="lead mb-0">
                                We're working on adding more educational resources, policies, and information to help our community stay informed and engaged.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CenterPhilMontessori;